import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import SEO from './components/SEO';
import WebVitals from './components/WebVitals';
import { initializeGA, trackPageView, trackEngagement } from './utils/analytics';
import Hero from './components/Hero';
import Features from './components/Features';
import Screenshots from './components/Screenshots';
import Download from './components/Download';
import Footer from './components/Footer';
import Feedback from './components/Feedback';
import Terms from './components/Terms';
import Privacy from './components/Privacy';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

const HomePage: React.FC = () => {
  useEffect(() => {
    // Initialize Google Analytics
    initializeGA();
    
    // Track page view for homepage
    trackPageView('/', 'ChoreTap - Home');

    // Track time on page for engagement
    const startTime = Date.now();
    const trackTimeOnPage = () => {
      const timeSpent = Math.round((Date.now() - startTime) / 1000);
      if (timeSpent > 10) { // Track if user spent more than 10 seconds
        trackEngagement(timeSpent);
      }
    };

    const handleBeforeUnload = () => trackTimeOnPage();
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <main role="main">
      <SEO />
      <WebVitals />
      <Hero />
      <Features />
      <Screenshots />
      <Download />
      <Footer />
    </main>
  );
};

const TermsPage: React.FC = () => {
  useEffect(() => {
    // Track page view for terms page
    trackPageView('/terms', 'ChoreTap - Terms of Service');
  }, []);

  return <Terms />;
};

const PrivacyPage: React.FC = () => {
  useEffect(() => {
    // Track page view for privacy page
    trackPageView('/privacy', 'ChoreTap - Privacy Policy');
  }, []);

  return <Privacy />;
};

const FeedbackPage: React.FC = () => {
  useEffect(() => {
    // Track page view for feedback page
    trackPageView('/feedback', 'ChoreTap - Feedback');
  }, []);

  return <Feedback />;
};

function App() {
  // Get basename from environment - defaults to "/" for production
  const basename = (process.env as any).REACT_APP_BASENAME || "/";
  
  return (
    <Router basename={basename}>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
